/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 09:46:58
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-06 11:07:12
 */
import React, { ReactElement, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { PSCRecordList } from './PSCRecordList/PSCRecordList'

export const PharmaceuticalServiceConsultationRecordTabs = (): ReactElement => {
  const location: any = useLocation()

  const [selectKey, setSelectKey] = useState<any>('0')

  return (
    <TabBar
      style={{ margin: '10px 20px' }}
      defaultActiveKey={
        location.state ? location.state.selectKey : selectKey || '0'
      }
      onChange={(v) => {
        setSelectKey(v)
      }}
    >
      <TabPane key='0' tab='药学服务咨询记录'>
        <PSCRecordList selectKey={selectKey}></PSCRecordList>
      </TabPane>
    </TabBar>
  )
}
